"use client"

import { useState, useRef } from "react"
import { FaTimes, FaImage, FaTrash } from "react-icons/fa"
import { useObservations } from "../context/ObservationContext"
import "./ObservationModal.css"

const ObservationModal = ({ isOpen, onClose, observation = null, selectedDate }) => {
  const [title, setTitle] = useState(observation?.title || "")
  const [description, setDescription] = useState(observation?.description || "")
  const [value, setValue] = useState(observation?.value ? observation.value.toString() : "")
  const [image, setImage] = useState(observation?.image || null)
  const [errors, setErrors] = useState({})

  const fileInputRef = useRef(null)

  const { addObservation, updateObservation } = useObservations()

  const handleImageChange = (e) => {
    const file = e.target.files[0]
    if (!file) return

    // Check file type
    if (!file.type.startsWith("image/")) {
      setErrors((prev) => ({ ...prev, image: "O arquivo deve ser uma imagem" }))
      return
    }

    // Check file size (max 5MB)
    if (file.size > 5 * 1024 * 1024) {
      setErrors((prev) => ({ ...prev, image: "A imagem deve ter no máximo 5MB" }))
      return
    }

    // Read file as data URL
    const reader = new FileReader()
    reader.onload = (event) => {
      setImage(event.target.result)
      setErrors((prev) => ({ ...prev, image: null }))
    }
    reader.readAsDataURL(file)
  }

  const handleRemoveImage = () => {
    setImage(null)
    if (fileInputRef.current) {
      fileInputRef.current.value = ""
    }
  }

  const validate = () => {
    const newErrors = {}

    if (!title.trim()) {
      newErrors.title = "O título é obrigatório"
    }

    if (value && isNaN(Number.parseFloat(value))) {
      newErrors.value = "O valor deve ser um número válido"
    }

    setErrors(newErrors)
    return Object.keys(newErrors).length === 0
  }

  const handleSubmit = (e) => {
    e.preventDefault()

    if (!validate()) return

    const observationData = {
      title: title.trim(),
      description: description.trim(),
      image,
      date: selectedDate, // Adicionar a data selecionada
    }

    if (observation) {
      updateObservation(observation.id, { ...observation, ...observationData })
    } else {
      addObservation(observationData)
    }

    onClose()
  }

  if (!isOpen) return null

  // Formatar a data para exibição
  const d = selectedDate.split("-")
  const formattedDate = `${d[2]}/${d[1]}/${d[0]}`

  return (
    <div className="observation-modal-overlay">
      <div className="observation-modal">
        <div className="observation-modal-header">
          <h2>{observation ? "Editar Observação" : "Nova Observação"}</h2>
          <button className="close-button" onClick={onClose}>
            <FaTimes />
          </button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="observation-modal-body">
            <div className="form-group">
              <label>Data</label>
              <input type="text" className="form-control" value={formattedDate} disabled />
            </div>

            <div className="form-group">
              <label htmlFor="title">Título</label>
              <input
                type="text"
                id="title"
                className={`form-control ${errors.title ? "is-invalid" : ""}`}
                value={title}
                onChange={(e) => setTitle(e.target.value)}
              />
              {errors.title && <div className="invalid-feedback">{errors.title}</div>}
            </div>

            <div className="form-group">
              <label htmlFor="description">Descrição</label>
              <textarea
                id="description"
                className="form-control"
                rows="4"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
              ></textarea>
            </div>

            {/* <div className="form-group">
              <label htmlFor="value">Valor (R$)</label>
              <input
                type="number"
                id="value"
                className={`form-control ${errors.value ? "is-invalid" : ""}`}
                value={value}
                onChange={(e) => setValue(e.target.value)}
                step="0.01"
              />
              {errors.value && <div className="invalid-feedback">{errors.value}</div>}
            </div> */}

            <div className="form-group">
              <label>Imagem</label>

              {image ? (
                <div className="image-preview-container">
                  <img src={image || "/placeholder.svg"} alt="Preview" className="image-preview" />
                  <button type="button" className="remove-image-button" onClick={handleRemoveImage}>
                    <FaTrash />
                  </button>
                </div>
              ) : (
                <div className="image-upload">
                  <input
                    type="file"
                    id="image"
                    ref={fileInputRef}
                    accept="image/*"
                    onChange={handleImageChange}
                    className="image-input"
                  />
                  <label htmlFor="image" className="image-upload-label">
                    <FaImage className="upload-icon" />
                    <span>Selecionar imagem</span>
                  </label>
                </div>
              )}

              {errors.image && <div className="invalid-feedback">{errors.image}</div>}
            </div>
          </div>

          <div className="observation-modal-footer">
            <button type="button" className="btn btn-secondary" onClick={onClose}>
              Cancelar
            </button>
            <button type="submit" className="btn btn-primary">
              {observation ? "Salvar" : "Adicionar"}
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}

export default ObservationModal

